<template lang="pug">
.it-recommend-vendor
  title-bar
    span {{ $t('Brief') }}
  div(style="margin-left: 20px")
    upload-file(
      :text="$t('附件')"
      :fileName="brief.brief_name"
      :downloadUrl="brief.brief_download_url"
    )
    el-row.row-content(style="margin:22px 0;line-height: 20px")
      el-col(:span="4") {{ $t('介绍') }}
      el-col(:span="10")
        display-text-container(:text="brief.remark")
    category(
      v-if='category.length'
      :data="category"
    )
  title-bar {{ $t('市场部推荐供应商情况') }}
  div(style="margin-left: 20px")
    marketing-recommend-vendor(
      :showCategory="false"
      :scope="marketRes.selected_scope"
      :vendor="marketRes.vendor"
      :remark="marketRes.remark"
    )
  title-bar {{ $t('IT推荐供应商') }}
  div(v-if="isView" style="margin-left: 20px")
    it-recommend-vendor(
      :vendor="recommendVendors.vendor"
      :remark="recommendVendors.remark"
      :isFinalScope="isFinalScope"
    )
  div(v-else style="margin-left: 20px")
    select-vendors-container(
      :selectedVendors="selectedVendors"
      :title="$t('选择供应商')"
      @change="(val) => selectedVendors = val"
      :categorys="[{category_id:5}]"
      :showUnauthorised="true"
      :disabledVendorList="selectedVendors"
    )
    el-row
      el-col(:span="4") {{ $t('备注') }}
      el-col(:span="20" style="position: relative")
        el-input(
          v-model="remark"
          type="textarea"
          :rows="8"
          style="width: 380px"
          :placeholder="$t('备注不多于500字')"
          :class="{'has-error': errors.has('remark_field') }"
          v-validate="'max:500'"
          data-vv-as="remark_field"
          name="remark_field"
        )
        p(class="input-error") {{ errors.first('remark_field') }}
  el-row(
    v-if="!isView"
    style="margin-left: 20px"
  )
    el-col(
      :span="20"
      :offset="4"
    )
      footer-button(
        :confirmButtonDisabled="selectedVendors.some(vendor => { return vendor.struct_group_id === null })"
        @confirm="onConfirm"
        @cancel="cancel"
      )
</template>
<script>
import Category from '@/components/Category'
import TitleBar from '@/components/TitleBar'
import UploadFile from '@/components/UploadFile'
import FooterButton from '@/components/FooterButton'
import MarketingRecommendVendor from '@/components/MarketingRecommendVendor'
import axios from 'axios'
import { format4backend } from '@/umcc/util'
import ItRecommendVendor from '@/components/ITRecommendVendor'
import SelectVendorsContainer from '@/components/SelectVendorsContainer'
import DisplayTextContainer from '@/components/DisplayTextContainer'

const fetchCategoryList = (campaignID, isFinalScope) => {
  return axios.get('/management/campaign/getCampaignOverview', {
    params: {
      campaign_id: campaignID
    }
  })
}
export default {
  components: {
    TitleBar,
    UploadFile,
    MarketingRecommendVendor,
    FooterButton,
    ItRecommendVendor,
    SelectVendorsContainer,
    DisplayTextContainer,
    Category
  },
  props: {
    isFinalScope: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      brief: {},
      marketRes: {
        selected_scope: [],
        vendor: [],
        remark: ''
      },
      recommendVendors: {
        vendor: [],
        remark: ''
      },
      cc: '',
      visible: false,
      businessLog: {},
      selectedVendors: [{
        is_storage: 1,
        struct_group_name: '',
        struct_group_id: null
      }],
      remark: '',
      category: []
    }
  },
  computed: {
    campaignId () {
      return this.$store.state.campaign.id
    },
    version () {
      return this.$store.state.campaign.campaignVersion
    }
  },
  mounted () {
    this.fetchBriefInfo()
    this.fetchMarketRecommend()
    this.fetchCategoryList()
    if (this.isView) {
      this.fetchBusinessLog()
      this.fetchITRecommend()
    }
  },
  methods: {
    fetchCategoryList () {
      fetchCategoryList(this.campaignId, this.isFinalScope).then(res => {
        this.category = res.category
      })
    },
    fetchBusinessLog () {
      axios.get('/common/getBusinessLog', {
        params: {
          servlet_path: this.$route.path,
          business_key: this.campaignId
        }
      })
        .then(res => {
          this.businessLog = res
        })
    },
    fetchBriefInfo () {
      axios
        .get('management/campaign/getBriefInfo', {
          params: {
            campaign_id: this.$store.state.campaign.id,
            is_final_scope: this.isFinalScope
          }
        })
        .then(res => {
          this.brief = res
        })
    },
    fetchMarketRecommend () {
      axios
        .get('management/campaign/getMarketRecommend', {
          params: {
            campaign_id: this.$store.state.campaign.id,
            is_final_scope: this.isFinalScope
          }
        })
        .then(res => {
          this.marketRes = res
        })
    },
    fetchITRecommend () {
      axios
        .get('management/campaign/getITRecommend', {
          params: {
            campaign_id: this.$store.state.campaign.id,
            is_final_scope: this.isFinalScope
          }
        })
        .then(res => {
          this.recommendVendors = {
            vendor: res.vendor,
            remark: res.remark
          }
        })
    },
    onConfirm () {
      this.$validator.validate().then(result => {
        if (result) {
          this.submit()
        }
      })
    },
    submit () {
      const loading = this.$loading()
      let params = {
        campaign_vendor_basic: {
          campaign_id: this.campaignId,
          is_final_scope: this.version > 'v2' ? this.isFinalScope : 1,
          remark: this.remark
        },
        campaign_vendor: this.selectedVendors.map(o => {
          return {
            vendor_id: o.struct_group_id,
            is_storage: o.is_storage
          }
        }),
        task_id: this.$store.state.campaign.taskId,
        servlet_path: this.$route.path,
        task_name: this.$store.state.campaign.taskName,
        business_type: this.$store.state.campaign.businessType
      }
      axios.post('/management/campaign/saveITRecommendedVendor', format4backend(params))
        .then(res => {
          const param = {
            campaign_id: this.campaignId,
            campaign_deliver_vendor: this.selectedVendors.map(o => {
              return {
                vendor_id: o.struct_group_id
              }
            })
          }
          axios
            .post('/management/campaign/saveCampaignDeliverVendor', format4backend(param))
            .then(res => {
              loading.close()
              this.$router.push('/campaign/process')
            })
            .catch(() => {
              loading.close()
            })
        })
        .catch(() => {
          loading.close()
        })
    },
    cancel () {
      this.$router.push('/campaign/process')
    }
  }
}
</script>
